import { ReactNode } from 'react';

import { mergeSx, Typography, Stack, tokens } from '@cast/design-system';

import type { TypographyProps, StackProps } from '@cast/design-system';

type Props = StackProps & {
  testId?: string;
  icon: ReactNode;
  title: string;
  titleTypographyProps?: TypographyProps;
  description: string;
  descriptionTypographyProps?: TypographyProps;
  cta?: ReactNode;
};

export const TrialBannerLayout = ({
  testId,
  icon,
  title,
  titleTypographyProps,
  description,
  descriptionTypographyProps,
  cta,
  sx,
  ...props
}: Props) => {
  return (
    <Stack
      data-testid={testId}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={32}
      sx={mergeSx(
        {
          backgroundColor: tokens.theme.bg.structural.surfaceInverse,
          py: 12,
          px: 16,
          mb: 16,
          borderRadius: '4px',
        },
        sx
      )}
      {...props}
    >
      <Stack direction="row" alignItems="center" gap={20}>
        {icon}
        <Stack gap={8}>
          <Typography
            variant="h5"
            color={tokens.theme.fg.structural.primaryOnInverse}
            {...titleTypographyProps}
          >
            {title}
          </Typography>
          <Typography
            variant="P12R"
            color={tokens.theme.fg.structural.secondaryOnInverse}
            {...descriptionTypographyProps}
          >
            {description}
          </Typography>
        </Stack>
      </Stack>

      {cta}
    </Stack>
  );
};
